var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EDEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14233_13611)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 16.5H26C27.1 16.5 28 17.4 28 18.5V28.5C28 29.6 27.1 30.5 26 30.5H14C12.9 30.5 12 29.6 12 28.5V18.5C12 17.4 12.9 16.5 14 16.5H15V14.5C15 11.74 17.24 9.5 20 9.5C22.76 9.5 25 11.74 25 14.5V16.5ZM20 11.5C18.34 11.5 17 12.84 17 14.5V16.5H23V14.5C23 12.84 21.66 11.5 20 11.5ZM14 28.5V18.5H26V28.5H14ZM22 23.5C22 24.6 21.1 25.5 20 25.5C18.9 25.5 18 24.6 18 23.5C18 22.4 18.9 21.5 20 21.5C21.1 21.5 22 22.4 22 23.5Z",
    fill: "#9E9E9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14233_13611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocked);
export default __webpack_public_path__ + "static/media/ic-locked.a733da51a7c7143123b640c8f151f027.svg";
export { ForwardRef as ReactComponent };